var exports = {
  "k": "x620889e6--59e563--container",
};

module.exports = exports;
